import { render, staticRenderFns } from "./MLCNotificationStatus.vue?vue&type=template&id=99b57864"
import script from "./MLCNotificationStatus.vue?vue&type=script&lang=js"
export * from "./MLCNotificationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports